import { createFileRoute } from '@tanstack/react-router'
import { ServicesFeature } from '@/features/services/ServicesFeature'

export const Route = createFileRoute('/services')({
  component: ServicesPage,
})

function ServicesPage() {
  return <ServicesFeature />
}
